import {combineReducers} from 'redux';
import serviceReducer from './Reducers/servicesReducer';
import userReducer from "./Reducers/userReducer";

export default combineReducers({
    services: serviceReducer,
    user: userReducer
});